import { useSoundPath } from "hooks/useSoundPath";
import { CraftIdentityContext } from "pages/CraftIdentity";
import React, { useContext, useRef } from "react";
import { createAPI } from "services/api/api";

const CraftIdentityMatchesItemButton = ({
  children,
  matchesRef,
  color,
  variables,
  id,
  setDetails,
  isLoading,
  setIsLoading
}) => {
  const api = createAPI();
  const playSound = useSoundPath();
  const { queryParams, firstSelectedCard } = useContext(CraftIdentityContext);

  const buttonRef = useRef(null);
  const hasFetched = useRef(false);

  const getIdentityInfo = () => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      setIsLoading(true)
      api
        .get(
          `/me/identities_matches/params?${queryParams}&id_selected=${firstSelectedCard.id}&celebrity_id=${id}`
        )
        .then((response) => {
          setDetails(response.data[0]);
          setIsLoading(false);
        })
        .catch((e) => {
          setIsLoading(false);
          console.log("getIdentityInfo error:", e);
          hasFetched.current = false;
        });
    }
  };

  const handleClick = (e) => {
    const button = e.currentTarget;
    const isCurrentlyActive = button.classList.contains("active");

    if (isCurrentlyActive) {
      button.classList.remove("active");
      playSound("closeSubmenu");
    } else {
      button.classList.add("active");
      playSound("openSubmenu");
      getIdentityInfo();
    }


    matchesRef.current?.update();
  };

  return (
    <button
      ref={buttonRef}
      className='card-details__craft-item-button card-details__craft-item-button--identity'
      style={{ "--data-color": color }}
      onClick={handleClick}
      aria-expanded={buttonRef.current?.classList.contains("active") || false}
    >
      <span className="card-details__craft-item-name">{children}</span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={isLoading ? 'loading' : ''}
      >
        <path
          d="M9.16667 9.16667H10V13.3333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <rect
          x="9.4335"
          y="6.1"
          width="1.13333"
          height="1.13333"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
      </svg>

      {variables.some((v) => v !== "") && (
        <span className="card-details__craft-item-variables">
          {variables.map(
            (variable, index) =>
              variable !== "" && (
                <span
                  className="card-details__craft-item-variables-item"
                  key={index}
                >
                  {variable}
                </span>
              )
          )}
        </span>
      )}
    </button>
  );
};

export default CraftIdentityMatchesItemButton;


// import { useSoundPath } from "hooks/useSoundPath";
// import { CraftIdentityContext } from "pages/CraftIdentity";
// import React, { useContext } from "react";
// import { createAPI } from "services/api/api";

// const CraftIdentityMatchesItemButton = ({ children, matchesRef, color, variables, id, setDetails }) => {

//   const api = createAPI();
//   const playSound = useSoundPath();

//   const {queryParams, firstSelectedCard} = useContext(CraftIdentityContext);

//   const getIdentityInfo = () => {
//     api.get(`/me/identities_matches/params?${queryParams}&id_selected=${firstSelectedCard.id}&celebrity_id=${id}`)
//     .then((response) => {
//       setDetails(response.data[0])
//     })
//     .catch((e) => {
//       console.log('getIdentityInfo', e);
//     })
//   }


//   return (
//     <button
//       className="card-details__craft-item-button card-details__craft-item-button--identity"
//       style={{
//         "--data-color": color,
//       }}
//       onClick={(e) => {
//         e.currentTarget.classList.toggle("active");
//         matchesRef.current.update();
//         if (!e.currentTarget.classList.contains('active')) {
//           playSound('openSubmenu');
//           getIdentityInfo();
//         } else {
//           playSound('closeSubmenu')
//         }
//       }}
//     >
//       <span className="card-details__craft-item-name">{children}</span>
//       <svg
//         width="20"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M9.16667 9.16667H10V13.3333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
//           stroke={color}
//           strokeWidth="1.5"
//           strokeLinecap="square"
//         />
//         <rect
//           x="9.4335"
//           y="6.1"
//           width="1.13333"
//           height="1.13333"
//           fill={color}
//           stroke={color}
//           strokeWidth="0.3"
//         />
//       </svg>
//       { variables.some((item) => item !== '') &&
//         <span className="card-details__craft-item-variables">
//           {
//             variables.map((variable, index) => {
//               if (variable !== '') {
//                 return <span className="card-details__craft-item-variables-item" key={index}>{variable}</span>
//               } else return null
//             })
//           }
//       </span>
//       }
//     </button>
//   );
// };

// export default CraftIdentityMatchesItemButton;
